import moment from "moment";

export default function makeAcademicYear(year) {
  return `${year} - ${moment(year).add(1, "y").year()}`;
}
